<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import {Link} from 'svelte-routing'
    import {Table} from 'sveltestrap'
    import Modal from 'src/components/#common/modal/Modal.svelte'
    import {doShow as showAlert} from '../../#common/alert/store'
    import IconifyIcon from '@iconify/svelte'
    import pinIcon from '@iconify/icons-fa-solid/bookmark'
    import editIcon from '@iconify/icons-fa-solid/edit'
    import viewIcon from '@iconify/icons-fa-solid/eye'
    import deleteIcon from '@iconify/icons-fa-solid/trash-alt'
    import {getAllArticles, updateArticle, deleteArticle} from 'src/components/cabinet/#services/blogArticles'
    import Pagination from 'src/components/#common/pagination/Pagination.svelte'
    import PerPage from 'src/components/#common/pagination/PerPage.svelte'

    let deleteModalOpen = false
    let selectedArticle
    let currentPage = 0
    let perPage = 25
    let maxButtons = 5

    function init() {
        getAllArticles.send({ data: { page: currentPage + 1, perPage } })
        $getAllArticles.value
    }
    $:currentPage,perPage,init()

    async function changePinned(id, isPinned) {
        try {
            await updateArticle.request({ data: { props: { id, isPinned }} })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            getAllArticles.reset()
            getAllArticles.send({ data: { page: currentPage + 1, perPage } })
        }
    }

    async function deleteSelectedArticle() {
        try {
            await deleteArticle.request({data: {id: selectedArticle}})

            deleteModalOpen = false

            showAlert.set({
                status: 'success',
                text: 'Article successful deleted!'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            getAllArticles.reset()
            getAllArticles.send({ data: { page: currentPage + 1, perPage } })
        }
    }
</script>

<svelte:head>
    <title>Blog</title>
</svelte:head>

<MainLayout title="Blog">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <Link to="blog/article/add" class="btn btn-success mb-3">Add article</Link>
                <Link to="blog/categories" class="btn btn-primary mb-3">Categories</Link>
                {#if $getAllArticles.hasValue}
                    <PerPage
                        bind:perPage={perPage}
                        disabled={$getAllArticles.loading || $getAllArticles.loading}
                        totalCount={$getAllArticles.value.totalCount}
                    />
                {/if}
                <div class="articles-list">
                    <Table bordered responsive>
                        <thead>
                        <tr>
                            <td class="text-center"><IconifyIcon icon={pinIcon}/></td>
                            <td>Title</td>
                            <td class="text-center d-none d-md-table-cell">Views</td>
                            <td class="text-center">Actions</td>
                        </tr>
                        </thead>
                        <tbody>
                            {#if !$getAllArticles.hasValue && $getAllArticles.loading}
                                <tr>
                                    <td class="text-center" colSpan="4">Loading...</td>
                                </tr>
                            {:else if !$getAllArticles.hasValue && $getAllArticles.error }
                                <tr>
                                    <td class="text-center" colspan="4">Something went wrong. Try refreshing the page.</td>
                                </tr>
                            {:else if $getAllArticles.value}
                                {#each $getAllArticles.value.data as { id, title, views, url, isPinned }}
                                    <tr>
                                        <td>
                                            {#if isPinned}
                                                <input type="checkbox" class="form-check-input" checked on:click={() => changePinned(id, false)}>
                                            {:else}
                                                <input type="checkbox" class="form-check-input" on:click={() => changePinned(id, true)}>
                                            {/if}
                                        </td>
                                        <td>{title}</td>
                                        <td class="text-center d-none d-md-table-cell">{views}</td>
                                        <td>
                                            <Link to="blog/article/edit/{id}" class="btn btn-primary" title="Edit">
                                                <IconifyIcon icon={editIcon}/>
                                            </Link>
                                            <a href="{process.env.BLOG_URL}{url}" class="btn btn-success" title="View" target="_blank" rel="noreferrer">
                                                <IconifyIcon icon={viewIcon}/>
                                            </a>
                                            <button class="btn btn-danger" title="Delete" on:click={() => { deleteModalOpen = true; selectedArticle = id }}>
                                                <IconifyIcon icon={deleteIcon}/>
                                            </button>
                                        </td>
                                    </tr>
                                {/each}
                            {/if}
                        </tbody>
                    </Table>
                    {#if $getAllArticles.hasValue}
                        <Pagination
                            bind:currentPage={currentPage}
                            totalCount={$getAllArticles.value.totalCount}
                            {perPage}
                            {maxButtons}
                            disabled={$getAllArticles.loading}
                        />
                    {/if}
                </div>
            </div>
        </div>
        <Modal bind:visible={deleteModalOpen} size="sm">
            <svelte:fragment slot="content">
                <div class="modal-custom__title">Delete article</div>
                <div class="modal-custom__text">Do you really want to delete the article?</div>
                <div class="modal-custom__footer">
                    <button class="btn btn-cancel" on:click={() => { deleteModalOpen = false }}>Close</button>
                    <button class="btn btn-primary" on:click={deleteSelectedArticle}>Yes</button>
                </div>
            </svelte:fragment>
        </Modal>
    </svelte:fragment>
</MainLayout>

<style>
    .articles-list :global(table) {
        width: auto;
    }

    .articles-list :global(tbody td) {
        vertical-align: middle;
        padding: 5px 10px;
        line-height: normal;
    }

    @media (max-width: 767px) {
        .articles-list td :global(.btn.btn-primary) {
            width: 38px;
            height: 38px;
            padding: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 auto 5px;
        }

        .articles-list td :global(.btn-success) {
            width: 38px;
            height: 38px;
            padding: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 auto 5px;
        }

        .articles-list td :global(.btn-danger) {
            width: 38px;
            height: 38px;
            padding: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 auto;
        }
    }
</style>
